import Helper from '@ember/component/helper'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'

interface Signature {
  Return: boolean
}
export default class IsSubco extends Helper<Signature> {
  @service session!: SessionService

  @service subscriptionType!: SubscriptionTypeService

  compute() {
    return this.subscriptionType.current && this.session.currentTeacher.subcoFor(this.subscriptionType.current)
  }
}
